/*
 * Nordic Tea (17/9): let snefald i de skovgroenne julefelter.
 * Bruges af forsidens julekort (.nt-teaser.nt-jul) og fordelsboksen paa
 * produktsider med julepynt (.cc-main-product .product.nt-jul .nt-usp).
 *
 * - Fnuggene viger for musen, saa det foeles levende.
 * - Koerer kun mens feltet er paa skaermen og fanen er aktiv.
 * - Ingen animation for folk der har slaaet bevaegelse fra i systemet.
 */
(() => {
  if (window.ntSne) return;
  window.ntSne = true;

  const FELTER = '.nt-teaser.nt-jul, .cc-main-product .product.nt-jul .nt-usp';
  const reduceret = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceret.matches) return;

  const tilfaeldig = (min, max) => min + Math.random() * (max - min);

  function lavFnug(bredde, hoejde, overalt) {
    const r = tilfaeldig(0.8, 2.6);
    return {
      x: tilfaeldig(0, bredde),
      y: overalt ? tilfaeldig(0, hoejde) : tilfaeldig(-hoejde * 0.2, -4),
      r,
      fart: tilfaeldig(0.25, 0.75) * (0.6 + r / 3),
      sving: tilfaeldig(0, Math.PI * 2),
      svingFart: tilfaeldig(0.006, 0.018),
      alfa: tilfaeldig(0.45, 0.95),
      vx: 0,
      vy: 0,
    };
  }

  function startFelt(felt) {
    if (felt.querySelector(':scope > canvas.nt-sne')) return;
    const canvas = document.createElement('canvas');
    canvas.className = 'nt-sne';
    canvas.setAttribute('aria-hidden', 'true');
    felt.prepend(canvas);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let bredde = 0;
    let hoejde = 0;
    let fnug = [];
    let koerer = false;
    let synlig = false;
    let mus = null;

    function tilpas() {
      const boks = felt.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      bredde = Math.max(1, Math.round(boks.width));
      hoejde = Math.max(1, Math.round(boks.height));
      canvas.width = bredde * dpr;
      canvas.height = hoejde * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const antal = Math.max(8, Math.min(90, Math.round((bredde * hoejde) / 7000)));
      while (fnug.length < antal) fnug.push(lavFnug(bredde, hoejde, true));
      fnug.length = antal;
    }

    function tegn() {
      if (!koerer) return;
      ctx.clearRect(0, 0, bredde, hoejde);
      for (const f of fnug) {
        f.sving += f.svingFart;
        if (mus) {
          const dx = f.x - mus.x;
          const dy = f.y - mus.y;
          const afstand = Math.hypot(dx, dy);
          if (afstand < 90 && afstand > 0.1) {
            const kraft = (1 - afstand / 90) * 0.9;
            f.vx += (dx / afstand) * kraft;
            f.vy += (dy / afstand) * kraft * 0.6;
          }
        }
        f.vx *= 0.94;
        f.vy *= 0.94;
        f.x += Math.sin(f.sving) * 0.35 + f.vx;
        f.y += f.fart + f.vy;
        if (f.y - f.r > hoejde || f.x < -20 || f.x > bredde + 20) Object.assign(f, lavFnug(bredde, hoejde, false));
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 252, 245, ${f.alfa})`;
        ctx.fill();
      }
      requestAnimationFrame(tegn);
    }

    function opdaterKoersel() {
      const skal = synlig && !document.hidden && !reduceret.matches;
      if (skal && !koerer) {
        koerer = true;
        requestAnimationFrame(tegn);
      } else if (!skal) {
        koerer = false;
      }
    }

    felt.addEventListener('pointermove', (evt) => {
      const boks = felt.getBoundingClientRect();
      mus = { x: evt.clientX - boks.left, y: evt.clientY - boks.top };
    });
    felt.addEventListener('pointerleave', () => { mus = null; });

    new ResizeObserver(tilpas).observe(felt);
    new IntersectionObserver((poster) => {
      synlig = poster.some((p) => p.isIntersecting);
      opdaterKoersel();
    }).observe(felt);
    document.addEventListener('visibilitychange', opdaterKoersel);
    reduceret.addEventListener?.('change', () => {
      opdaterKoersel();
      if (reduceret.matches) ctx.clearRect(0, 0, bredde, hoejde);
    });
    tilpas();
  }

  const init = () => document.querySelectorAll(FELTER).forEach(startFelt);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
